import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=2310fdbb&scoped=true&lang=pug&"
import script from "./Checkout.vue?vue&type=script&lang=js&"
export * from "./Checkout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2310fdbb",
  null
  
)

export default component.exports